var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhRide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1136_5455",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1136_5455)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2877 1.97095V2.43285C10.2877 2.85146 10.2877 3.27006 10.2877 3.68866C10.2877 3.87516 10.2877 3.87487 10.5097 3.87487C11.593 3.87487 12.6764 3.86765 13.7604 3.87487C15.2724 3.88699 16.6231 4.3079 17.7904 5.14511C18.9418 5.97105 19.6712 7.02651 19.986 8.29733C19.996 8.33832 20.0013 8.38047 20.0129 8.44687H19.8377C18.5553 8.44687 17.2726 8.44687 15.9899 8.44918C15.8751 8.44918 15.8154 8.41367 15.7537 8.33371C15.2638 7.68733 14.5701 7.3562 13.6798 7.35215C12.613 7.34725 11.5463 7.35417 10.4795 7.34927C10.3255 7.34927 10.2821 7.38882 10.2841 7.52075C10.2917 8.04039 10.2874 8.56004 10.2874 9.07968V9.25665L3.90625 5.61019L10.2877 1.97095Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.692 22.0292V21.5895C13.692 21.1565 13.687 20.7235 13.6946 20.2904C13.6969 20.1637 13.6512 20.1262 13.5055 20.127C12.4441 20.1316 11.3826 20.1345 10.3211 20.127C8.36399 20.1155 6.71968 19.4835 5.42003 18.2043C4.69026 17.4875 4.22587 16.6512 3.99367 15.7158C3.98239 15.6702 3.97808 15.6234 3.9668 15.5559H4.14493C5.42169 15.5559 6.69912 15.5559 7.97555 15.5533C8.09464 15.5533 8.16097 15.5865 8.22732 15.6737C8.71493 16.314 9.4049 16.6451 10.2879 16.6506C11.3494 16.6575 12.4109 16.6523 13.4724 16.6506C13.6903 16.6506 13.691 16.6506 13.691 16.4589C13.691 15.9012 13.691 15.3434 13.691 14.7452L20.0705 18.3891L13.692 22.0292Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1219 9.67894C20.0317 10.0176 19.9664 10.3735 19.841 10.713C19.2807 12.2307 18.1748 13.3523 16.5355 14.0619C15.3459 14.5766 13.9673 13.9955 13.6708 12.8727C13.5724 12.4966 13.6209 12.1028 13.8086 11.7534C13.9963 11.4039 14.3124 11.1189 14.7071 10.9434C15.3118 10.6761 15.7463 10.2872 15.9815 9.73091C15.9934 9.70973 16.0109 9.6913 16.0325 9.6771C16.0541 9.66291 16.0792 9.65335 16.1059 9.6492C17.4206 9.64574 18.7353 9.64574 20.05 9.6492C20.0596 9.64834 20.0692 9.65613 20.1219 9.67894Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.87891 14.3413C3.9691 13.6001 4.23281 12.8829 4.65378 12.2338C5.28643 11.2419 6.25419 10.4433 7.4259 9.94624C8.44061 9.5083 9.64275 9.85444 10.142 10.7257C10.6412 11.597 10.2415 12.6311 9.23506 13.0754C8.64594 13.3352 8.22898 13.7232 7.99744 14.2636C7.98425 14.2867 7.965 14.3067 7.94126 14.322C7.91751 14.3374 7.88995 14.3476 7.86079 14.352C6.55649 14.3563 5.25187 14.3551 3.94658 14.3546C3.9236 14.3519 3.90095 14.3475 3.87891 14.3413Z",
    fill: "#F5F5F5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhRide);
export default __webpack_public_path__ + "static/media/wh_ride.ba84a8b8f791aed1b6dfc7f29a878211.svg";
export { ForwardRef as ReactComponent };